export const RULE_IDS = {
  YEAR_PILLAR_LAP_XUAN: 'PILLAR_YEAR_LAP_XUAN',
  MONTH_PILLAR_SOLAR_TERM: 'PILLAR_MONTH_SOLAR_TERM',
  DAY_PILLAR_JDN_ROLLOVER: 'PILLAR_DAY_JDN_ROLLOVER',
  HOUR_PILLAR_ZI_BOUNDARY: 'PILLAR_HOUR_ZI_BOUNDARY',
  DAY_MASTER_STRENGTH: 'DM_STRENGTH_SEASON_BODY',
  USEFUL_GODS_CORE: 'DM_USEFUL_GODS_CORE'
};

export const RULE_METADATA = {
  [RULE_IDS.YEAR_PILLAR_LAP_XUAN]: {
    ruleVersion: 'pillars-v1',
    scope: 'pillars.year',
    outputPaths: ['tu_tru.nam', 'pillar_rules.year'],
    ruleTitle_vi: 'Trụ năm theo Lập Xuân',
    explain_vi: 'Năm đổi theo Lập Xuân, Can/Chi = (năm−3) mod 10/12 trên dãy Giáp…Quý/Tý…Hợi.'
  },
  [RULE_IDS.MONTH_PILLAR_SOLAR_TERM]: {
    ruleVersion: 'pillars-v1',
    scope: 'pillars.month',
    outputPaths: ['tu_tru.thang', 'pillar_rules.month'],
    ruleTitle_vi: 'Trụ tháng theo tiết khí',
    explain_vi: 'Chi tháng theo 24 tiết khí (Lập Xuân = tháng Dần); Can tháng tra bảng Niên thượng khởi nguyệt theo Can năm.'
  },
  [RULE_IDS.DAY_PILLAR_JDN_ROLLOVER]: {
    ruleVersion: 'pillars-v1',
    scope: 'pillars.day',
    outputPaths: ['tu_tru.ngay', 'pillar_rules.day'],
    ruleTitle_vi: 'Trụ ngày JDN + rollover 23h',
    explain_vi: 'Khóa Can/Chi ngày bằng JDN + reference; tùy chọn rolloverAt23 cho khung 23:00–23:59.'
  },
  [RULE_IDS.HOUR_PILLAR_ZI_BOUNDARY]: {
    ruleVersion: 'pillars-v1',
    scope: 'pillars.hour',
    outputPaths: ['tu_tru.gio', 'pillar_rules.hour'],
    ruleTitle_vi: 'Trụ giờ giờ Tý đặc biệt',
    explain_vi: 'Ánh xạ 12 địa chi giờ (2h/chi, Tý = 23:00–00:59); Can giờ tra Nhật thượng khởi thời.'
  },
  [RULE_IDS.DAY_MASTER_STRENGTH]: {
    ruleVersion: 'strength-v1',
    scope: 'analysis.dayMaster',
    outputPaths: ['analysis.dayMaster', 'analysis.season'],
    ruleTitle_vi: 'Định thân vượng/nhược theo mùa',
    explain_vi: 'Mùa cùng hành/sinh Nhật chủ ⇒ thân vượng; mùa khắc Nhật chủ ⇒ thân nhược; còn lại trung hòa.'
  },
  [RULE_IDS.USEFUL_GODS_CORE]: {
    ruleVersion: 'useful-gods-v1',
    scope: 'favorableElements',
    outputPaths: ['favorableElements.roles', 'favorableElements.reasoning'],
    ruleTitle_vi: 'Dụng/Hỷ/Kỵ thần lõi',
    explain_vi: 'Suy dụng/hỷ/kỵ dựa trên thân vượng/nhược; trung hòa ưu tiên hành của mùa, hành trội ≥ 0.4 ưu tiên hành khắc hành trội.'
  }
};

export const getRuleMeta = (ruleId) => ({
  ruleId,
  ruleVersion: RULE_METADATA[ruleId]?.ruleVersion || 'unknown',
  explain_vi: RULE_METADATA[ruleId]?.explain_vi || '',
  scope: RULE_METADATA[ruleId]?.scope || null,
  outputPaths: RULE_METADATA[ruleId]?.outputPaths || [],
  ruleTitle_vi: RULE_METADATA[ruleId]?.ruleTitle_vi || null
});
